export { default } from "./Indicator-component";
